<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
  >
    <v-card
      v-if="loading"
      class="d-flex justify-center"
    >
      <v-progress-circular
        :size="80"
        :width="5"
        color="primary"
        indeterminate
      />
    </v-card>

    <v-card v-else>
      <v-card-title>
        <span class="headline">Delete Payin Fee</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <p>
                Deleted fee cannot be returned, are you sure you want to
                delete this?
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="onClose">
          Cancel
        </v-btn>
        <v-btn
          color="error"
          :loading="loading"
          :disabled="loading"
          @click="onSubmit"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeletePayinFeeModal",

  props: {
    value: {
      type: Boolean,
      default: false
    },
    feeItem: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      loading: false,
      formData: {}
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    filterStringPayload() {
      const filter = this.feeItem;
      return `sourceCountryCode:${ filter.sourceCountryCode },sourceCurrencyCode:${ filter.sourceCurrencyCode },payInMethod:${ filter.payInMethod },paymentProvider:${ filter.paymentProvider }`;
    }
  },

  created() {
    this.getPrefilledFees();
  },

  methods: {
    async getPrefilledFees () {
      this.loading = true;

      await this.$store
        .dispatch("PayinFeesStore/getPrefilledFees", {
          page: 1,
          size: 50,
          filter: this.filterStringPayload
        })
        .then((res) => {
          const data = res.list;
          this.onPrefillFormData(data);
        })
        .finally(() => this.loading = false);
    },

    onPrefillFormData (data) {
      const fees = [];
      if (data && data.length) {
        fees.push({
          sourceCountryCode: data[0].sourceCountryCode,
          sourceCurrencyCode: data[0].sourceCurrencyCode,
          payInMethod: data[0].payInMethod,
          paymentProvider: data[0].paymentProvider
        });
      }

      this.$set(this.formData, 'fees', fees);
    },

    onSubmit () {
      this.loading = true;

      this.$store
        .dispatch("PayinFeesStore/deleteFees", this.formData)
        .then(() => {
          this.$emit("on-delete");
          this.onClose();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onClose() {
      this.dialog = false;
    }
  }
};
</script>
